import buildService, { NoParams } from 'common/utils/build-service'
import { GET } from 'common/requests'

export default buildService<NoParams, unknown, unknown, unknown>({
  type: GET,
  constantsPrefix: 'GRADES',
  isArray: true,
  http: {
    createApiUrlSuffix: () => '/grades?select=id,name',
  },
})
